import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MapPinIcon, PlusIcon } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { images } from "../data/site";
import { programmeSchedule, practicalInfo, faq } from "../data/pages";
export function Programme() {
  const [active, setActive] = useState(0);
  const day = programmeSchedule[active];
  return <PageShell title={<>Trois jours <span className="italic" data-id="element-348" data-mp="7cg5zn0x8cvo">sous les voiles</span></>} intro="Du vendredi 23 au dimanche 25 juin 2028, Mieussy célèbre les 50 ans du parapente. Programme provisoire, susceptible d'évoluer selon la météo." image={images.festival} imageAlt="Des parapentes colorés au-dessus d'une prairie remplie de spectateurs" data-id="element-347" data-mp="7dhk60d8hfhm">
      <section className="mx-auto max-w-[1320px] px-5 py-24 md:px-10 md:py-28" aria-labelledby="schedule-title" data-id="element-349" data-mp="2i73jm5u2r65f">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end" data-id="element-350" data-mp="2d77pcyb6it32">
          <h2 id="schedule-title" className="font-serif text-4xl md:text-6xl" data-id="element-351" data-mp="3a36vfhgh23ac">Le programme</h2>
          <div role="tablist" aria-label="Jours du festival" className="flex rounded-full bg-sand p-1.5" data-id="element-352" data-mp="3f3cq76i1g5wn">
            {programmeSchedule.map((d, i) => <button key={d.day} role="tab" aria-selected={active === i} onClick={() => setActive(i)} className={`whitespace-nowrap rounded-full px-4 py-2.5 text-sm font-semibold transition-colors duration-150 md:px-6 ${active === i ? "bg-navy text-cream" : "text-navy hover:bg-sky/60"}`} data-id="element-353" data-mp="305ammwb0bkfe" data-mpi={i}>
                {d.day} {d.date.split(" ")[0]}
              </button>)}
          </div>
        </div>

        <AnimatePresence mode="wait" data-id="element-354" data-mp="2mef7j29x073d">
          <motion.div key={day.day} role="tabpanel" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-12 grid gap-10 lg:grid-cols-12" data-id="element-355" data-mp="28emn1oozen3u">
            <div className="lg:col-span-4" data-id="element-356" data-mp="e4xwz397guyz">
              <p className="text-sm font-semibold uppercase tracking-wide text-red" data-id="element-357" data-mp="97fmv9jgc9pe">{day.day}</p>
              <p className="font-serif text-6xl" data-id="element-358" data-mp="48csqk50fnw7">{day.date}</p>
              <p className="mt-3 text-xl" data-id="element-359" data-mp="49xizxkakko9">{day.title}</p>
            </div>
            <ol className="divide-y divide-navy/15 border-y border-navy/15 lg:col-span-8" data-id="element-360" data-mp="11v21dcu7wyr1">
              {day.slots.map(s => <li key={s.time + s.title} className="grid grid-cols-[72px_1fr] gap-4 py-6 md:grid-cols-[110px_1fr_auto] md:items-center" data-id="element-361" data-mp="wxtcyuih7yhc">
                  <span className="font-serif text-2xl" data-id="element-362" data-mp="nwlr5bx5cq45">{s.time}</span>
                  <span className="text-lg font-medium" data-id="element-363" data-mp="nyohxy64in9x">{s.title}</span>
                  <span className="col-start-2 flex items-center gap-1.5 text-sm text-navy-soft md:col-start-auto" data-id="element-364" data-mp="3cppp4oh358ei">
                    <MapPinIcon className="h-4 w-4" data-id="element-365" data-mp="38onnk0zp4k9d" /> {s.place}
                  </span>
                </li>)}
            </ol>
          </motion.div>
        </AnimatePresence>
      </section>

      <section className="bg-navy text-cream" aria-labelledby="info-title" data-id="element-366" data-mp="1s413zoqu9b5w">
        <div className="mx-auto max-w-[1320px] px-5 py-24 md:px-10" data-id="element-367" data-mp="1x3nh7y6o2rep">
          <h2 id="info-title" className="font-serif text-4xl md:text-6xl" data-id="element-368" data-mp="21w6roma256fa">Infos <span className="italic" data-id="element-369" data-mp="26v06qj4zt5hk">pratiques</span></h2>
          <div className="mt-12 grid gap-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-370" data-mp="26ui3h2jwxr05">
            {practicalInfo.map(info => <div key={info.title} className="border-t border-cream/25 pt-6" data-id="element-371" data-mp="2bw7ewjb1s6or">
                <h3 className="text-lg font-semibold" data-id="element-372" data-mp="2fw7sk1qbodur">{info.title}</h3>
                <p className="mt-3 leading-relaxed text-cream/75" data-id="element-373" data-mp="2kv19y58qcp07">{info.text}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1000px] px-5 py-24 md:px-10 md:py-28" aria-labelledby="faq-title" data-id="element-374" data-mp="lk1jb8gzo753">
        <h2 id="faq-title" className="font-serif text-4xl md:text-6xl" data-id="element-375" data-mp="3rbzcudefuv95">Questions <span className="italic" data-id="element-376" data-mp="3ra4un6ujxh8r">fréquentes</span></h2>
        <div className="mt-10 divide-y divide-navy/15 border-y border-navy/15" data-id="element-377" data-mp="3mdo1tzceqepc">
          {faq.map(item => <details key={item.q} className="group py-6" data-id="element-378" data-mp="53g9xt0o2cug">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-6 text-lg font-medium [&::-webkit-details-marker]:hidden" data-id="element-379" data-mp="5xy9uv9ljir">
                {item.q}
                <PlusIcon className="h-5 w-5 shrink-0 text-red transition-transform duration-200 group-open:rotate-45" data-id="element-380" data-mp="38j580caj4jin" />
              </summary>
              <p className="mt-3 max-w-2xl leading-relaxed text-navy-soft" data-id="element-381" data-mp="3ibjflloagkcq">{item.a}</p>
            </details>)}
        </div>
      </section>
    </PageShell>;
}